/**
 * Dispensing Status Enum
 *
 * Values synced with backend DispensingStatusEnum.
 * @see backend/src/backend/db/constants/dispensing_status.py
 *
 * Backend values:
 * - PENDING = 1
 * - DISPENSED = 2
 * - CANCELED = 3
 * - NOT_DISPENSED = 4
 */
import { intl } from "dmsbasereact";

export const DispensingStatusEnum = {
    PENDING: 1,
    DISPENSED: 2,
    CANCELED: 3,
    NOT_DISPENSED: 4,
};

export const DispensingStatus = {
    getText: (code) => {
        switch (code) {
            case DispensingStatusEnum.PENDING:
                return intl.get("Pending").d("Pending");
            case DispensingStatusEnum.DISPENSED:
                return intl.get("Dispensed").d("Dispensed");
            case DispensingStatusEnum.CANCELED:
                return intl.get("Canceled").d("Canceled");
            case DispensingStatusEnum.NOT_DISPENSED:
                return intl.get("NotDispensed").d("Not Dispensed");
            default:
                return intl.get("Unknown").d("Unknown");
        }
    },
    getColor: (code) => {
        switch (code) {
            case DispensingStatusEnum.PENDING:
                return "warning";
            case DispensingStatusEnum.DISPENSED:
                return "success";
            case DispensingStatusEnum.CANCELED:
                return "error";
            case DispensingStatusEnum.NOT_DISPENSED:
                return "default";
            default:
                return "default";
        }
    }
};

/**
 * Get dispensing status options for select components
 * @returns {Array} Array of {value, label} objects
 */
export const getDispensingStatusOptions = () => [
    { value: DispensingStatusEnum.PENDING, label: DispensingStatus.getText(DispensingStatusEnum.PENDING) },
    { value: DispensingStatusEnum.DISPENSED, label: DispensingStatus.getText(DispensingStatusEnum.DISPENSED) },
    { value: DispensingStatusEnum.CANCELED, label: DispensingStatus.getText(DispensingStatusEnum.CANCELED) },
    { value: DispensingStatusEnum.NOT_DISPENSED, label: DispensingStatus.getText(DispensingStatusEnum.NOT_DISPENSED) }
];
